import React from 'react'
import injectSheet from 'react-jss'
import styles from './student-displayname.styles'
import Paper from 'pobble-components/dist/paper'
import Section from '../../../shared/section/section'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import Button from 'pobble-components/dist/button'
import classNames from 'classnames'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { validateDisplayName } from 'pobble-components/dist/validators'

const StudentDisplayName = ({
  classes,
  pending,
  displayName,
  onSubmit,
  onClick
}) => (
  <Paper className={classes.paper}>
    <Formik
      onSubmit={onSubmit}
      initialValues={{
        displayName: displayName || ''
      }}
      validationSchema={Yup.object().shape({
        displayName: validateDisplayName().required(
          'Please provide a display name'
        )
      })}>
      {formikProps => {
        const {
          values,
          handleBlur,
          handleChange,
          handleSubmit,
          isValid,
          touched,
          errors
        } = formikProps
        return (
          <form
            onSubmit={handleSubmit}
            className={classNames(classes.form, {
              [classes.pending]: pending
            })}>
            <Section
              className={classes.section}
              pending={pending}
              title="Choose your display name">
              <div className={classes.container}>
                <FormInput
                  name="displayName"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.displayName}
                  placeholder={'Ex: DonaldDuck'}
                  big
                  className={classes.input}
                  validationError={touched.displayName && errors.displayName}
                />
                {/*

                // #6103

                <Button
                  className={classes.button}
                  secondary
                  action={() =>
                    onClick().then(name => setFieldValue('displayName', name))
                  }
                  big>
                  New <RefreshIcon />
                </Button>

              */}
              </div>
              <div className={classes.action}>
                <Button
                  className={classes.button}
                  disabled={!isValid}
                  type="submit"
                  big>
                  Save
                </Button>
              </div>
            </Section>
          </form>
        )
      }}
    </Formik>
  </Paper>
)

export default injectSheet(styles)(StudentDisplayName)
